<template>
  <BaseIcon
    :showIcon="showIcon"
    imgSrc="/img/icons/live_studies_icon.svg"
    imgAlt="Live Studies Icon"
    :iconText="iconText"
    tooltipContentClass="live-studies-status-tooltip"
    dataCy="liveStudiesStatus"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import BaseIcon from './BaseIcon.vue'

export default defineComponent({
  name: 'LiveStudiesStatus',
  components: {
    BaseIcon
  },
  props: {
    deviceId: {
      type: String,
      default: ''
    }
  },
  computed: {
    isDeviceConnected(): boolean {
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_IS_CONNECTED_BY_DEVICE_ID}`
      ](this.deviceId)
    },
    isLivePresent(): boolean {
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_IS_LIVE_PRESENT_BY_DEVICE_ID}`
      ](this.deviceId)
    },
    iconText(): string {
      if (this.isDeviceConnected && this.isLivePresent) {
        return this.$t('device.icons.liveStudiesStatus')
      }

      return ''
    },
    showIcon(): boolean {
      return !!this.iconText
    }
  }
})
</script>
